module.exports = __webpack_public_path__ + "static/media/img5.d8ca9208.PNG";